import { COOKIE_DISCLAIMER_TOKEN } from '../constants/tokens';
import { SET_COOKIE_CONFIRMATION_FULFILLED } from '../constants/cookies.actions';
import { setCookie } from '../helpers/cookies';

export const setCookieConfirmation = (value) => {
	setCookie(COOKIE_DISCLAIMER_TOKEN, value);
	return {
		type: SET_COOKIE_CONFIRMATION_FULFILLED,
		payload: {
			value
		}
	};
};
